/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 1229:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5671);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(136);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2963);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1120);
/* harmony import */ var _babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7112);
/* harmony import */ var _services_filter_sections__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1423);
/* harmony import */ var _utils_body_lock__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1709);






function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }




var FilterInteraction = /*#__PURE__*/function (_HTMLElement) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(FilterInteraction, _HTMLElement);

  var _super = _createSuper(FilterInteraction);

  function FilterInteraction() {
    var _this;

    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, FilterInteraction);

    _this = _super.call(this);

    var fieldset = _this.querySelector('fieldset');

    var drawer = document.querySelector('.filter-drawer');
    var section_id = drawer.dataset.sectionId ? drawer.dataset.sectionId : null;

    var activeFilters = _this.querySelectorAll('.js-active-button');

    var resultsButton = _this.querySelector('.js-results');

    var removeAllFilters = _this.querySelector('.delete-holder__button');

    var collapsable = _this.querySelectorAll('.js-collapsable'); // enhances the urlSearchParams prototype remove function so we can delete a param by value


    URLSearchParams.prototype.remove = function (key, value, url) {
      var entries = url.searchParams.getAll(key);
      var newEntries = entries.filter(function (entry) {
        return entry !== value;
      });
      url.searchParams.delete(key);
      newEntries.forEach(function (newEntry) {
        return url.searchParams.append(key, newEntry);
      });
    };
    /**
     * 
     * @param {Event} e 
     * @param {URL} url 
     */


    var changeAndRenderUrl = function changeAndRenderUrl(e, url) {
      var currentFilter = url.searchParams.get("".concat(e.target.dataset.url));

      if (currentFilter && url.href.includes(e.target.dataset.filter) === false) {
        url.searchParams.append("".concat(e.target.dataset.url), e.target.dataset.filter);
        (0,_services_filter_sections__WEBPACK_IMPORTED_MODULE_2__/* .filterSections */ .R)(url.toString() + "&section=".concat(section_id));
      } else {
        url.searchParams.set("".concat(e.target.dataset.url), e.target.dataset.filter);
        (0,_services_filter_sections__WEBPACK_IMPORTED_MODULE_2__/* .filterSections */ .R)(url.toString() + "&section=".concat(section_id));
      }
    };
    /**
     * 
     * @param {Event} e 
     */


    var handleUrlChange = function handleUrlChange(e) {
      var url = new URL(window.location);

      if (e.target.checked) {
        changeAndRenderUrl(e, url);
      } else {
        url.searchParams.remove("".concat(e.target.dataset.url), e.target.dataset.filter, url);
        document.querySelector(".boxes [data-filter='".concat(e.target.dataset.filter, "']")).checked = false;
        url.toString().includes('?') ? (0,_services_filter_sections__WEBPACK_IMPORTED_MODULE_2__/* .filterSections */ .R)(url.toString() + "&section=".concat(section_id)) : (0,_services_filter_sections__WEBPACK_IMPORTED_MODULE_2__/* .filterSections */ .R)(url.toString() + "?section=".concat(section_id));
      }

      history.pushState('filter', '', url);
    };

    var removeFilters = function removeFilters() {
      var url = new URL(window.location);
      url.searchParams.forEach(function (filter, key) {
        url.searchParams.remove(key, filter, url);
      });
      history.pushState('remove filters', '', url);
      (0,_services_filter_sections__WEBPACK_IMPORTED_MODULE_2__/* .filterSections */ .R)(url.toString() + "?section=".concat(section_id));
      drawer.classList.add('filter-drawer--hidden');
      document.querySelectorAll(".quick-filter .filter-checkboxes .checkbox-list .boxes input").forEach(function (inp) {
        inp.checked = false;
      });
    };

    if (fieldset) {
      fieldset.addEventListener('change', function (e) {
        handleUrlChange(e);
      });
    }

    if (activeFilters && resultsButton && removeAllFilters) {
      activeFilters.forEach(function (filter) {
        filter.addEventListener('click', function (e) {
          handleUrlChange(e);
        });
      });
      resultsButton.addEventListener('click', function () {
        // window.innerWidth <= 600 ? bodyLock.unlock() : null
        _utils_body_lock__WEBPACK_IMPORTED_MODULE_3__/* ["default"].unlock */ .Z.unlock();
        drawer.classList.add('filter-drawer--hidden');
      });
      removeAllFilters.addEventListener('click', function (e) {
        removeFilters();
      });
    }

    if (collapsable) {
      collapsable.forEach(function (item) {
        item.addEventListener('click', function (e) {
          item.nextElementSibling.classList.toggle('checkbox-list--open');
          item.closest('.js-collapsable').classList.toggle('text-holder--active');
        });
      });
    }

    return _this;
  }

  return FilterInteraction;
}( /*#__PURE__*/(0,_babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(HTMLElement)); // Check if element is defined, if not define it..


if (customElements.get('filter-interaction') === undefined) {
  customElements.define('filter-interaction', FilterInteraction);
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	!function() {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = function(result, chunkIds, fn, priority) {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var chunkIds = deferred[i][0];
/******/ 				var fn = deferred[i][1];
/******/ 				var priority = deferred[i][2];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every(function(key) { return __webpack_require__.O[key](chunkIds[j]); })) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/runtimeId */
/******/ 	!function() {
/******/ 		__webpack_require__.j = 1519;
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	!function() {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			1519: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = function(chunkId) { return installedChunks[chunkId] === 0; };
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = function(parentChunkLoadingFunction, data) {
/******/ 			var chunkIds = data[0];
/******/ 			var moreModules = data[1];
/******/ 			var runtime = data[2];
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some(function(id) { return installedChunks[id] !== 0; })) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkIds[i]] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkworkflow"] = self["webpackChunkworkflow"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [1216], function() { return __webpack_require__(1229); })
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;